<script setup lang="ts">
import { type RouteLocationRaw, RouterLink } from "vue-router";

const props = defineProps<{
  isSelected?: boolean;
  route: RouteLocationRaw;
}>();

const emit = defineEmits<{
  click: [];
}>();

const onClick = (event: MouseEvent) => {
  // Enable the user to use browser shortcuts
  if (event.ctrlKey || event.metaKey) {
    return;
  }

  event.preventDefault();
  emit("click");
};
</script>

<template>
  <div class="le-results-list-button" :class="{ 'le-results-list-button--selected': props.isSelected }">
    <RouterLink v-slot="{ href }" custom :to="props.route">
      <a
        :href="href"
        class="le-results-list-button__button"
        :class="{ 'le-results-list-button__button--selected': props.isSelected }"
        @click="onClick($event)"
      >
        <slot name="content" />
      </a>
    </RouterLink>

    <slot name="icon" />
  </div>
</template>

<style lang="less" scoped>
@import "@dsk/styles/all";

.le-results-list-button {
  position: relative;
  transition: background-color 75ms ease-out;
  background-color: @colors[@neutrals][100];

  &:hover {
    background-color: @colors[@secondary][200];
  }

  &--selected {
    background-color: @colors[@accent][300];

    &:hover {
      background-color: @colors[@accent][400];
    }
  }

  &__button {
    display: block;
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 7px 16px;
    border: 0;
    border-radius: 4px;
    background: none;
    color: @colors[@neutrals][400];
    text-align: left;

    #media-breakpoint-up(lg, {
      padding: 14px 16px;
    });

    &--selected {
      color: @colors[@neutrals][500];
    }

    &.focus-visible {
      position: relative;
      .focus-outline(green);
    }
  }

  &--selected &__button.focus-visible {
    .focus-outline(yellow);
  }
}
</style>
